module.exports = __webpack_public_path__ + "img/returnGameLeft.8dce2a60.png";